import * as immu from 'object-path-immutable'

// -----------------------------------------
// Drugs from index:substance for ids array
// -----------------------------------------
export function drugsByIds( ids ) {

  return async ( dispatch, getState, api ) => {

    // Parse result
    const drugs = {}

    // Quality control
    if ( !ids || Array.isArray( ids ) == false || ids.length == 0 ) {
      return drugs
    }

    const { meta, data } = await api.simple.list( {
      index: "substance",
      body: { ids }
    } )

    // Parse result
    if ( meta.code == 200 && Array.isArray( data ) ) {
      for ( const drug of data ) {
        drugs[ drug.id ] = {
          id: drug.id,
          name: drug.name,
          atc: drug.atc,
          form: drug.form,
          applw: drug.applw,
          alt: drug.alt || []
        }
      }
    } else {
      console.log( "Error: elastic.substanceByIds failed" )
      if ( process.env.NODE_ENV == "develop" ) {
        console.log( meta )
        console.log( data )
      }
    }

    return drugs

  }

}